import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export const searchCars = async (query) => {
    const q = (query || "").trim();
    const url = new URL(`${API_BASE}/cars/client/search`);
    url.searchParams.set("query", q);

    const res = await apiFetch(url.toString());
    if (!res.ok) {
        const txt = await res.text();
        throw new Error("Не вдалося знайти авто: " + txt);
    }
    return await res.json();
};
